"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ProximityOperator", {
  enumerable: true,
  get: function get() {
    return _Proximity["default"];
  }
});

var _Proximity = _interopRequireDefault(require("./Proximity"));